import styled from 'styled-components';
import { BoxOutline } from '@/general/box/outline';

export const EmptyBox = styled(BoxOutline)`
  height: 100%;
  background-color: var(--color-grey-1300);
`;
